import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {DataResponseWrapper} from '@deezer/next/services/api/Starmania/requests/types';
import type {Country, Offer} from './types';

const {get} = requestWrapper;

const requests = {
	getCountries: () => get<DataResponseWrapper<Country[]>>(endpoints.countries),
	getOffers: () => get<DataResponseWrapper<Offer[]>>(endpoints.offers),
};

export default requests;
